module.exports = new __parcel__URL__("voice-search.62a918f2.png").toString();